import { StaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'
import { Link } from '../components/localizedlink'

class Header extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      open: false
    }
  }

  toggleMenu(e){
    e.preventDefault();
    this.setState(state => ({open: !state.open}));
  }

  render() {
    const { navigation, locale } = this.props;
    const { open } = this.state;

    return <StaticQuery
      query={graphql`
        query {
          logo: file(relativePath: {eq: "logo-white-iid.png"}) {
            childImageSharp {
              fluid{
                ...GatsbyImageSharpFluid
              }
            }
          }
          logoBlack: file(relativePath: {eq: "contents/logo-black-iid.png"}) {
            childImageSharp {
              fluid{
                ...GatsbyImageSharpFluid
              }
            }
          } 
        }
      `}
      render={data => (
        <div className={`header ${open ? 'header--menu-open' : ''}`}>
          <div className="container">
            <div className="row hidden-sm hidden-xs">
              <div className="col-sm-12">
                <div className="header__translations">
                  <Link className={`header__translations__link ${locale === 'it' ? 'header__translations__link--active' : ''}`} literal="true" to="/">
                    IT
                  </Link>
                  <span>/</span>
                  <Link className={`header__translations__link ${locale === 'en' ? 'header__translations__link--active' : ''}`} literal="true" to="/en/">
                    EN
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="clearfix">
                  <div className="logo">
                    <Link className="logo__link" to="/">
                      <Img fluid={data.logo.childImageSharp.fluid} alt="Intranet Italia Day" className="logo__img logo__img--white" />
                      <Img fluid={data.logoBlack.childImageSharp.fluid} alt="Intranet Italia Day" className="logo__img logo__img--black" />
                    </Link>
                    <div className="logo__name visuallyhidden"><strong>INTRANET ITALIA DAY</strong></div>
                  </div>
                  <div className="header__info">Intranet Italia Day<span><br/><FormattedMessage id="milano-10-11"/></span></div>
                  <a href="/" title="Mostra/Nascondi menu" id="toggle-menu-btn" className={`hamburger ${open ? 'open' : ''}`}
                    onClick={e => this.toggleMenu(e)}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </a>
                  {!!navigation.header && (
                    <nav id="nav" className="" itemType="http://schema.org/SiteNavigationElement" itemScope="itemscope" role="navigation"
                      style={{display: open ? 'block' : 'none'}}>
                      <ul className="navigation" role="menu" aria-orientation="horizontal">
                        <li className="navigation__item visible-sm visible-xs">
                          <div className="navigation__translations">
                            <Link className={`navigation__translation__link ${locale === 'it' ? 'navigation__translation__link--active' : ''}`} literal="true" to="/">
                              IT
                            </Link>
                            <span>/</span>
                            <Link className={`navigation__translation__link ${locale === 'en' ? 'navigation__translation__link--active' : ''}`} literal="true" to="/en/">
                              EN
                            </Link>
                          </div>
                        </li>
                        {navigation.header.map((item, i)  => (
                          <li className={`navigation__item ${i === 0 ? 'navigation__item--first' : ''}`} role="menuitem" itemProp="name" key={i}>
                            <Link to={item.link} title={item.name}
                              className="navigation__link" activeClassName="navigation__link--active" itemProp="url">
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  }

}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header;
